import { isIgnoredConsoleMessage } from './ignore';
const TIMESTAMP_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/;
const MODULE_RE = /^\[(.+)]$/;
const safeStringify = (value) => {
    try {
        return JSON.stringify(value) ?? String(value);
    }
    catch (e) {
        return String(value);
    }
};
const stringifyArgument = (arg) => {
    if (typeof arg === 'string') {
        return arg;
    }
    return safeStringify(arg);
};
/**
 * Разбирает аргументы @jitsi/logger: [timestamp, '[module]', '<caller>: ', ...message].
 *
 * @param {Array} args - Аргументы вызова console.error.
 * @returns {Object} - Модуль логгера и текст без таймстемпа.
 */
const parseLoggerArguments = (args) => {
    const rest = [...args];
    if (typeof rest[0] === 'string' && TIMESTAMP_RE.test(rest[0])) {
        rest.shift();
    }
    let module = 'unknown';
    const moduleMatch = typeof rest[0] === 'string' ? MODULE_RE.exec(rest[0]) : null;
    if (moduleMatch) {
        module = moduleMatch[1];
        rest.shift();
    }
    // имя вызывающей функции минифицировано и меняется от сборки к сборке
    if (typeof rest[0] === 'string' && /^<.*>:\s*$/.test(rest[0])) {
        rest.shift();
    }
    const text = rest
        .map(stringifyArgument)
        .join(' ')
        .trim();
    return {
        module,
        text
    };
};
// убираем из текста то, что меняется от события к событию, чтобы группировка была стабильной
const normalize = (text) => text
    .replace(/https?:\/\/\S+/g, '<url>')
    .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '<uuid>')
    .replace(/\d+/g, '<n>')
    .slice(0, 200);
/**
 * Обрабатывает событие из captureConsoleIntegration.
 *
 * Если в logger.error передан Error — это пойманное исключение, отправляем как есть.
 * Если только строки — либо отбрасываем (известный шум),
 * либо отправляем как warning, сгруппированный по модулю и тексту без таймстемпа.
 *
 * @param {ErrorEvent} event - Событие sentry.
 * @returns {ErrorEvent|null} - Null, если событие не нужно отправлять.
 */
export const processConsoleEvent = (event) => {
    const args = event.extra?.arguments;
    if (!Array.isArray(args)) {
        return event;
    }
    const { module, text } = parseLoggerArguments(args);
    if (isIgnoredConsoleMessage(text)) {
        return null;
    }
    event.tags = {
        ...event.tags,
        'failure.kind': 'console',
        'logger.module': module
    };
    if (event.exception) {
        return event;
    }
    event.level = 'warning';
    event.message = `[${module}] ${text}`;
    event.fingerprint = ['console', module, normalize(text)];
    return event;
};
